import axiosInstance from "../utils/axios"

export const positionService = {
  fetchAllWithoutPaginate: async () => {
    try {
      const response = await axiosInstance.get('/position/all')
      return response.data
    } catch {
      const response = await axiosInstance.get('/position', { params: { limit: 1000 } })
      return response.data
    }
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/position',{ params })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/position/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/position', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/position/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/position/${id}`)
    return response.data
  },
}
